import { useUserStore } from './stores/user'
import { useSpreadInfoStore } from './stores/spreadInfo'
import { texts } from './config/brands'

function getDeviceId(): string {
  return localStorage.getItem('device-uuid') || ''
}

function getBrowserLanguage(): string {
  const lang = navigator.language || 'en'
  const map: Record<string, string> = {
    'en': 'en',
    'zh-TW': 'zh-hant',
    'ja': 'ja',
    'ko': 'ko',
    'fr': 'fr',
    'de': 'de',
    'es': 'es',
    'id': 'id',
  }
  return map[lang] || map[lang.split('-')[0]] || 'en'
}

const payload: Record<string, any> = {
  app: 'pc-novel',
  cm: {
    versionCode: __APP_VERSION__,
    platform: 'pc',
    content_type: '4',
    contentType: '4',
    client_time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    clientGroupName: texts?.clientGroupName,
    language: getBrowserLanguage(),
    ua: window.navigator.userAgent,
    hw: `${window.innerHeight}X${window.innerWidth}`,
    member_code: '',
    member_id: '',
    equipmentId: '',
    landingPageType: '',
    utm_campaign_id: '',
    utm_medium: '',
    utm_adset_id: '',
    utm_ad_id: '',
    pId: '',
    adDomainId: '',
    bizAdId: '',
  },
}

function tracking(et: any[]) {
  try {
    const userStore = useUserStore()
    payload.cm.member_id = userStore.userInfo?.memberId || ''
    payload.cm.member_code = userStore.userInfo?.code || ''
  }
  catch {}

  try {
    const spreadInfoStore = useSpreadInfoStore()
    payload.cm.landingPageType = spreadInfoStore.landingPageType
    payload.cm.utm_campaign_id = spreadInfoStore.utm_campaign_id
    payload.cm.utm_medium = spreadInfoStore.utm_medium
    payload.cm.utm_adset_id = spreadInfoStore.utm_adset_id
    payload.cm.utm_ad_id = spreadInfoStore.utm_ad_id
    payload.cm.pId = spreadInfoStore.pId
    payload.cm.adDomainId = spreadInfoStore.adDomainId
    payload.cm.bizAdId = spreadInfoStore.bizAdId
  }
  catch {}

  payload.cm.client_t = Date.now()
  payload.cm.equipmentId = getDeviceId()

  const data = { app: payload.app, cm: { ...payload.cm }, et }

  try {
    const trackPrefix = (import.meta.env as any).VITE_TRACK_PREFIX
    if (!trackPrefix)
      return
    fetch(`${location.origin}/${trackPrefix}/tracking/report`, {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json',
        'platform': 'pc',
        'timezone': Intl.DateTimeFormat().resolvedOptions().timeZone,
        'equipmentId': getDeviceId() || '',
        'language': getBrowserLanguage(),
      },
      keepalive: true,
    })
  }
  catch (error) {
    console.error('Track fetch error:', error)
  }
}

export function newTrack(name: string, params: Record<string, any>) {
  const et = [{ ett: Date.now(), en: name, kv: params }]
  tracking(et)
}

let asyncEt: any[] = []
let asyncTimer: ReturnType<typeof setTimeout> | null = null

export function asyncTrack(name: string, params: Record<string, any>) {
  asyncEt.push({ ett: Date.now(), en: name, kv: params })
  if (!asyncTimer) {
    asyncTimer = setTimeout(() => {
      tracking(asyncEt)
      asyncEt = []
      asyncTimer = null
    }, 5000)
  }
}
